import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { LanguageGuard } from '@whbabtec-guards';
import { WHBABTEC_DEFAULT_LANG } from './shared/types/languages.type';
import { SigninOidcComponent } from './wh-babtec/modules/signin-oidc/signin-oidc.component';
import { SigninOidcModule } from './wh-babtec/modules/signin-oidc/signin-oidc.module';

const routes: Routes = [
  {
    path: '',
    redirectTo: `${WHBABTEC_DEFAULT_LANG}/login`,
    pathMatch: 'full',
  },
  {
    path: 'signin-oidc',
    component: SigninOidcComponent,
  },
  {
    path: ':lang',
    loadChildren: () =>
      import('./wh-babtec/wh-babtec.module').then((m) => m.WhBabtecModule),
    canActivate: [LanguageGuard],
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes, {}), SigninOidcModule],
  exports: [RouterModule],
})
export class AppRoutingModule {}
